// extracted by mini-css-extract-plugin
export default {"columnHeader":"Statistics_columnHeader__fHDlP","cell":"Statistics_cell__-6rFy","rowHeader":"Statistics_rowHeader__GEcjE"};